export class NOTIFYID {
    Type: string = "NOTIFYID";
    HasChange: boolean;
}